<template lang="pug">
  .products-results.px-40.md-px-5vw.text-16.md-text-18(style="overflow-anchor:none")
    //- (searching...)
    template(v-if="!productsFiltered")

    //- (results)
    template(v-else-if="productsFiltered.length")
      ul.md-flex.flex-wrap
        //- products...
        li.w-full.md-w-1x2.mb-100.lg-mb-75.xl-mb-90(v-for="(doc, i) in productsFiltered", v-show="vis(i)", :key="doc.handle")
          product-thumb.md-mx-5vw(:doc="doc", :visible="vis(i)")
      //- (load more btn)
      footer.-mt-40.lg-mt-20.text-11.md-text-13.flex.flex-wrap.justify-center(v-if="hasNextPage || isTruncated")
        //- (count)
        p.mb-20.w-full.text-center(v-if="isTruncated") Viewed {{limit}} of {{productsFiltered.length}} products
        //- btn
        button.btn-theme-outlined(@click="more", :disabled="querying")
          btn.min-w-160(theme="inherit")
            | {{querying ? 'Loading...' : 'Load More' }}

    //- (no results)
    .text-center.md-mt-em(v-else)
      p.text-18.md-text-16 No results
      button.btn-theme-outlined.inline-block.mt-36.min-w-btn(@click="viewAll")
        btn(theme="inherit") View All
</template>

<script>
import { mapState } from 'vuex'
import ProductThumb from './ProductThumb'
import kb from 'lodash/kebabCase'
export default {
  name: 'ProductsResults',
  props: ['products', 'truncate', 'hasNextPage'],
  data () {
    return {
      limit: this.truncate ? 10 : 0
    }
  },
  computed: {
    ...mapState({ querying: state => state.shop.querying }),
    productsFiltered () {
      if (!this.products) return null
      let products = this.products
      const qry = this.$route.query
      const arr = str => str && str.split(',').length ? str.split(',') : false
      const types = arr(qry.tag)
      const makers = arr(qry.maker)
      const genders = arr(qry.gender)
      const colours = arr(qry.colour)
      const sizes = arr(qry.size)
      const matches = (tags, prefix, active) => {
        return tags
          .filter(tg => tg.includes(prefix)) // filter tag list by group/prefix
          .map(tg => tg.split(':')[1]) // rmv group name 'gender:male' > 'male'
          .find(tg => active.includes(kb(tg))) // see if active (kebabCase from rt query)
      }
      // go !
      if (types) {
        products = products.filter(prd => prd.tags.find(tag => types.includes(kb(tag))))
      }
      if (makers) {
        products = products.filter(prd => makers.includes(kb(prd.vendor)))
      }
      if (genders) {
        products = products.filter(prd => matches(prd.tags, 'gender:', genders))
      }
      if (sizes) {
        products = products.filter(prd => matches(prd.tags, 'size:', sizes))
      }
      if (colours) {
        products = products.filter(prd => matches(prd.tags, 'colour:', colours))
      }
      return products
    },
    isTruncated () {
      return this.truncate && this.productsFiltered.length > this.limit
    }
  },
  methods: {
    more () {
      this.$emit('more')
      this.limit += 10
    },
    vis (i) {
      return !this.truncate || i < this.limit
    },
    viewAll () {
      if (this.productsFiltered.length < this.products.length) {
        return this.$router.replace({ query: {} })
      } else if (this.products && !this.products.length) {
        // no products, return to index
        return this.$router.push({ name: 'products' })
      }
    }
  },
  components: { ProductThumb }
}
</script>

<style>
</style>
